(ns practitest.frontend.components2.confirmation-modal
  (:require
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components2.buttons :as buttons]))

(defn confirmation-modal [{:keys [show? show-footer?
                                  title 
                                  on-confirm on-cancel
                                  confirmation-button-text cancel-button-text
                                  modal-class]
                           :or   {show?        true
                                  show-footer? true}}
                          body]
  [:<>
   [modal/bootstrap-modal
    {:class            modal-class
     :is-open?         show?
     :on-request-close on-cancel
     :close-button?    true
     :centered?        true
     :footer-class     "justify-content-center"
     :title-class      "justify-content-center"}
    [:<>
     [icons/mux-notification-error]
     [:p title]]
    body
    (when show-footer?
      [:<>
       (when cancel-button-text
         [buttons/button {:size     "large"
                          :on-click on-cancel
                          :text     cancel-button-text}])
       (when confirmation-button-text
         [buttons/button {:primary? true
                          :size     "large"
                          :class    "btn-delete"
                          :on-click on-confirm
                          :text     confirmation-button-text}])])]])
